"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.previousIcon = exports.nextIcon = exports.lastIcon = exports.firstIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var firstIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.41",
  height: "12",
  viewBox: "0 0 12.41 12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_2463",
  "data-name": "Path 2463",
  d: "M18.41,16.59,13.82,12l4.59-4.59L17,6l-6,6,6,6ZM6,6H8V18H6Z",
  transform: "translate(-6 -6)"
}));

exports.firstIcon = firstIcon;

var previousIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7.41",
  height: "12",
  viewBox: "0 0 7.41 12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_2459",
  "data-name": "Path 2459",
  d: "M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z",
  transform: "translate(-8 -6)"
}));

exports.previousIcon = previousIcon;

var nextIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7.41",
  height: "12",
  viewBox: "0 0 7.41 12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_2461",
  "data-name": "Path 2461",
  d: "M10,6,8.59,7.41,13.17,12,8.59,16.59,10,18l6-6Z",
  transform: "translate(-8.59 -6)"
}));

exports.nextIcon = nextIcon;

var lastIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.41",
  height: "12",
  viewBox: "0 0 12.41 12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_2465",
  "data-name": "Path 2465",
  d: "M5.59,7.41,10.18,12,5.59,16.59,7,18l6-6L7,6ZM16,6h2V18H16Z",
  transform: "translate(-5.59 -6)"
}));

exports.lastIcon = lastIcon;